// Routes match the old Wix site's URLs so existing links & search results keep working
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  RENTALS: "/rental-repairs",
  CONTACT: "/contact",
  REFUNDS: "/returnsandrefunds",
  //The Wix shop: /category/all-products, /category/devices... (see SHOP_CATEGORIES)
  SHOP: "/category/all-products",
  CATEGORY: "/category/:categorySlug",
  PRODUCT: "/product-page/:productSlug",
  CART: "/cart-page",
  ORDER_RESULT: "/order/:result",
  //One page per course: /microblading, /coolsculpt... (see data/courses.js)
  COURSE: "/:courseSlug",
};

export const getProductRoute = (slug) => (
  PAGE_ROUTES.PRODUCT.replace(":productSlug", slug)
);

export const getCategoryRoute = (slug) => (
  PAGE_ROUTES.CATEGORY.replace(":categorySlug", slug)
);

export const getCourseRoute = (slug) => (
  PAGE_ROUTES.COURSE.replace(":courseSlug", slug)
);

// The Wix store categories. A product's Category field lists the ones it's in ("Devices, Derma 2.0").
// inMenu: in the "Online Shop" menu (Derma 2.0 & Macno are only in the shop's "Browse by" list).
export const SHOP_CATEGORIES = [
  { name: "All Products", slug: "all-products" },
  { name: "Derma 2.0", slug: "derma-20" },
  { name: "Devices", slug: "devices", inMenu: true },
  { name: "Equipment", slug: "equipment", inMenu: true },
  { name: "Laser College Training", slug: "laser-college-training", inMenu: true },
  { name: "Laser Elect Products", slug: "laser-elect-products", inMenu: true },
  { name: "Macno", slug: "macno" },
  { name: "Numbing Creams", slug: "numbing-creams", inMenu: true },
  { name: "Skin Care", slug: "skin-care", inMenu: true },
  { name: "Training Courses", slug: "training-courses", inMenu: true },
];
export const ALL_PRODUCTS = "all-products";

//Courses are booked, not couriered: a cart with only these needs no delivery address
export const COURSE_CATEGORIES = ["Training Courses", "Laser College Training"];

export const CONTACT_DETAILS = {
  EMAIL: "info@thelashandbrowacademy.co.za",
  PHONE: "+27(0) 72 847 9985",
  PHONE_LINK: "tel:+27728479985",
  ADDRESS: "Hazeldean Office Park, Pelican Place, Suite 6 Hazeldean, Silverlakes, Pretoria, Gauteng, South Africa",
  MAP: "https://www.google.com/maps/search/?api=1&query=Hazeldean+Office+Park+Pelican+Place+Silverlakes+Pretoria",
  HOURS: ["Monday – Friday: 08:00 – 17:00", "Saturday & Sunday: Closed", "Public Holidays: Closed"],
  FACEBOOK: "https://www.facebook.com/TheLashandBrowAcademySA/",
  INSTAGRAM: "https://www.instagram.com/thelashandbrowacademy/",
  TAPX: "https://www.tap-x.com/",
};

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};


//"Interested in" on the Rental & Repairs form
export const RENTAL_TOPICS = ["Rental", "Repair"];

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
];
